module.exports = __webpack_public_path__ + "img/Fakeeh.37fdb11b.png";